export default "__VITE_ASSET__NwX1WQkd__"